<template>
  <el-table
    :data="tableData"
    border
    :header-cell-style="{
      background: '#F2F3F5',
      color: '#1D2129',
      fontSize: '12px',
    }"
    :cell-style="{ fontSize: '12px' }"
    cell-class-name="cell-value"
    class="block-campus-table"
  >
    <el-table-column label="更新时间" width="90px" prop="update_time">
      <template #default="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="moment(scope.row.update_time).format('YYYY.MM.DD')"
          placement="top-start"
        >
          <div>{{ moment(scope.row.update_time).format("YYYY.MM.DD") }}</div>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="招聘公告" width="140px" prop="title">
      <template #default="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="scope.row.title"
          placement="top-start"
        >
          <div @click="clickRowTitle(scope.row)">{{ scope.row.title }}</div>
        </el-tooltip>
        <div
          v-if="scope.row.internal_code"
          class="internal-btn"
          @click="copyInternalCode(scope.row.internal_code)"
        >
          复制内推
        </div>
        <div
          v-if="scope.row.label_text"
          class="label-text"
          :style="returnLabelColor(scope.row.label_color)"
        >
          {{ scope.row.label_text }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="企业性质" width="80px" prop="company_nature">
      <template #default="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="scope.row.company_nature"
          placement="top-start"
        >
          <div>{{ scope.row.company_nature }}</div>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="企业全称/行业" width="140px" prop="company_name">
      <template #default="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="scope.row.company_name"
          placement="top-start"
        >
          <div>{{ scope.row.company_name }}</div>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="岗位" width="100px" prop="post">
      <template #default="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="scope.row.post"
          placement="top-start"
        >
          <div>{{ scope.row.post }}</div>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="城市" width="80px" prop="city">
      <template #default="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="scope.row.city"
          placement="top-start"
        >
          <div>{{ scope.row.city }}</div>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="网申时间" width="100px">
      <template #default="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="
            !scope.row.end_at
              ? '尽快投递'
              : `${moment(scope.row.start_at).format('YYYY.MM.DD')}至${moment(
                  scope.row.end_at
                ).format('YYYY.MM.DD')}`
          "
          placement="top-start"
        >
          <div>
            {{
              !scope.row.end_at
                ? "尽快投递"
                : `${moment(scope.row.start_at).format("YYYY.MM.DD")}至${moment(
                    scope.row.end_at
                  ).format("YYYY.MM.DD")}`
            }}
          </div>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="招聘批次" width="80px" prop="batch">
      <template #default="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="scope.row.batch"
          placement="top-start"
        >
          <div>{{ scope.row.batch }}</div>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="学历要求" width="80px" prop="degree">
      <template #default="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="scope.row.degree"
          placement="top-start"
        >
          <div>{{ scope.row.degree }}</div>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="求职进度" width="120px">
      <template #default="scope">
        <el-select
          :value="scope.row.step"
          size="small"
          @change="stepChange(scope.row, $event)"
        >
          <el-option
            v-for="(item, index) in applicationStatuses"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </template>
    </el-table-column>
    <el-table-column label="操作">
      <template #default="scope">
        <div class="action-list">
          <div class="action-item" @click="clickAction(scope.row, 1)">投递</div>
          <div class="action-item" @click="clickAction(scope.row, 2)">
            {{ scope.row.remark ? "已备注" : "备注" }}
          </div>
          <button
            class="action-item"
            :disabled="!!scope.row.step_date"
            @click="clickAction(scope.row, 3)"
          >
            {{ scope.row.step_date ? "已添加" : "加到日历" }}
          </button>
        </div>
      </template>
    </el-table-column>
    <template slot="empty">
      <div class="empty-content">
        <img
          class="empty-icon"
          src="https://logo.wondercv.com/banners/pG8IcrNXL1lLt7m.png"
          alt=""
        />
        <p class="empty-text">暂无匹配职位</p>
      </div>
    </template>
  </el-table>
</template>
<script>
import api from "@/api";
import { copyToClipboard } from "../../assets/js/util.js";
import { APPLICATION_STATUSES, LABEL_COLOR } from "./const.js";
import { mapState } from "vuex";

const moment = require("moment");
export default {
  name: "BlockCampusTable",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    isLogin: Boolean,
  },
  data() {
    return {
      moment,
      applicationStatuses: APPLICATION_STATUSES,
    };
  },
  computed: {
    ...mapState("me", ["personInfo"]),
    isSchoolRecruitMembership() {
      return this.personInfo.is_school_recruit_membership;
    },
  },
  methods: {
    displayLoginModal() {
      this.$emit("displayLoginModal");
    },
    returnLabelColor(value) {
      const colorItem = LABEL_COLOR.find((item) => item.value === value);
      if (!colorItem) return {};
      return {
        background: colorItem.background,
        color: colorItem.color,
      };
    },
    async clickAction(row, type) {
      if (!this.isLogin) return this.displayLoginModal();
      if (!this.isSchoolRecruitMembership) return this.$emit("buyMember");
      const { deliver_url, deliver_email } = row;
      switch (type) {
        case 1:
          if (deliver_email) {
            await copyToClipboard(deliver_email);
            this.$message.success("HR 邮箱已复制，请尽快投递");
          } else if (deliver_url) {
            window.open(deliver_url, "_blank");
          }
          break;
        case 2:
          this.$emit("clickRemark", row);
          break;
        case 3:
          this.$emit("clickAddCalendar", row);
          break;
      }
    },
    async copyInternalCode(code) {
      if (!this.isLogin) return this.displayLoginModal();
      if (!this.isSchoolRecruitMembership) return this.$emit("buyMember");
      await copyToClipboard(code);
      this.$message.success("内推信息已复制到剪切板");
    },
    clickRowTitle(row) {
      if (!this.isLogin) return this.displayLoginModal();
      if (!this.isSchoolRecruitMembership) return this.$emit("buyMember");
      if (!row.recruitment_url) return;
      window.open(row.recruitment_url, "_blank");
    },
    async stepChange(row, value) {
      if (!this.isLogin) {
        return this.displayLoginModal();
      }
      if (!this.isSchoolRecruitMembership) return this.$emit("buyMember");
      try {
        const res = await api.campus.changeRecruiteStep(row.id, {
          step: value,
        });
        if (res.code === 1000) {
          this.$message.success("求职进度已更新");
          row.step = value;
        } else if (res.code === 200106) {
          this.$emit("buyMember");
        }
      } catch (error) {
        this.$message.error("求职进度更新失败");
      }
    },
  },
};
</script>
<style lang="scss">
.block-campus-table .cell-value .cell {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4; /* 限制为4行 */
  cursor: pointer;
  height: 100%;
}
.action-list {
  display: flex;
  align-items: center;
  .action-item {
    cursor: pointer;
    white-space: nowrap;
    color: #ff6644;
    padding: 0;
    background: none;
    &:not(:last-child) {
      margin-right: 8px;
    }
    &:disabled {
      cursor: not-allowed;
      opacity: 0.4;
    }
  }
}
.block-campus-table {
  border-radius: 12px;
  border: 1px solid #ebeef5;
  .internal-btn {
    display: flex;
    align-items: center;
    margin-top: 4px;
    padding: 0 4px;
    border-radius: 4px;
    background: #f2f3f5;
    color: #4b596b;
    cursor: pointer;
    width: fit-content;
    height: 18px;
    font-size: 10px;
  }
  .label-text {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    padding: 4px;
    border-radius: 0 0 6px 0;
    font-size: 9px;
    height: 17px;
    line-height: 17px;
    background: #f2f3f5;
    color: #4b596b;
  }
}
.empty-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 440px;
  .empty-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
  }
  .empty-text {
    color: #84909d;
    font-size: 14px;
  }
}
</style>
<style lang="scss">
.block-campus-table {
  &::after,
  &::before {
    display: none;
  }
  .el-table__body-wrapper {
    .el-table__body {
      tbody {
        .el-table__row {
          height: 117px;
          td:last-child {
            border-right: none;
          }
          &:last-child {
            td {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
}
</style>
